/**
 * Mockup Preview — Tshirtgang
 * Composites customer-uploaded decoration images onto the product mockup
 * using the HTML5 Canvas API. Switches the background mockup image based
 * on the active placement view (front/back/side).
 *
 * Alt-text convention for product images:
 *   Include "front", "back", or "side" anywhere in the alt text.
 *   Examples: "Black Front", "Navy Back", "White Side"
 *   If no keyword match is found, the first product image is used.
 */
(function () {
  'use strict';

  var PLACEMENTS = {
    front:        { label: 'Front',        w: 11,  h: 15,  view: 'front',  pct: { x: 0.28, y: 0.15, w: 0.44, h: 0.50 } },
    back:         { label: 'Back',         w: 11,  h: 15,  view: 'back',   pct: { x: 0.28, y: 0.22, w: 0.44, h: 0.50 } },
    sleeve_left:  { label: 'Left Sleeve',  w: 3.5, h: 3.5, view: 'side',   pct: { x: 0.02, y: 0.20, w: 0.18, h: 0.18 } },
    sleeve_right: { label: 'Right Sleeve', w: 3.5, h: 3.5, view: 'side',   pct: { x: 0.80, y: 0.20, w: 0.18, h: 0.18 } },
    chest_left:   { label: 'Left Chest',   w: 3.5, h: 3.5, view: 'front',  pct: { x: 0.52, y: 0.24, w: 0.18, h: 0.14 } },
    chest_right:  { label: 'Right Chest',  w: 3.5, h: 3.5, view: 'front',  pct: { x: 0.30, y: 0.24, w: 0.18, h: 0.14 } },
    yoke:         { label: 'Yoke',         w: 4,   h: 3,   view: 'back',   pct: { x: 0.30, y: 0.14, w: 0.40, h: 0.12 } },
    neck_inner:   { label: 'Inner Neck',   w: 3,   h: 2,   view: 'neck',   pct: { x: 0.38, y: 0.08, w: 0.24, h: 0.08 } },
    name_plate:   { label: 'Name Plate',   w: 12,  h: 3,   view: 'back',   pct: { x: 0.20, y: 0.68, w: 0.60, h: 0.08 } }
  };

  var activeTab = null;
  var uploadedImages = {};
  var canvas, ctx;
  var availablePlacements = [];
  var imgRect = { x: 0, y: 0, w: 800, h: 800 };

  var viewImages = {};
  var currentMockup = null;

  function loadProductImages() {
    var dataEl = document.getElementById('mockup-image-data');
    var images = [];
    if (dataEl) {
      try { images = JSON.parse(dataEl.textContent); } catch (e) {}
    }

    var keywords = { front: 'front', back: 'back', side: 'side', neck: 'neck' };
    var matched = {};

    for (var i = 0; i < images.length; i++) {
      var alt = (images[i].alt || '').toLowerCase();
      var keys = Object.keys(keywords);
      for (var k = 0; k < keys.length; k++) {
        var kw = keys[k];
        if (!matched[kw] && alt.indexOf(kw) > -1) {
          matched[kw] = images[i].src;
        }
      }
    }

    var fallbackSrc = null;
    if (images.length > 0) {
      fallbackSrc = images[0].src;
    } else {
      var productImg = document.querySelector(
        '.product-gallery img, .product-media img, .product__media img, ' +
        '[data-product-media] img, .media img, .product-info img'
      );
      if (productImg) fallbackSrc = productImg.currentSrc || productImg.src;
    }

    var views = ['front', 'back', 'side', 'neck'];
    for (var v = 0; v < views.length; v++) {
      var src = matched[views[v]] || fallbackSrc;
      if (src) { viewImages[views[v]] = loadImg(src); }
    }

    currentMockup = viewImages.front || viewImages.back || null;
  }

  function loadImg(src) {
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () { draw(); };
    if (src.indexOf('//') === 0) src = 'https:' + src;
    img.src = src;
    return img;
  }

  function buildPreviewHTML() {
    availablePlacements = [];
    var html = '<div class="mp-header"><h3 class="mp-title">Design Preview</h3>';
    html += '<span class="mp-subtitle">Select a placement to preview</span></div>';
    html += '<div class="mp-tabs">';
    var keys = Object.keys(PLACEMENTS);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i], p = PLACEMENTS[k];
      var cb = document.getElementById('check_' + k);
      if (!cb) continue;
      availablePlacements.push(k);
      html += '<button class="mp-tab" data-placement="' + k + '">';
      html += p.label + ' <span class="mp-tab__size">' + p.w + '\u00d7' + p.h + '\u2033</span>';
      html += '</button>';
    }
    html += '</div>';
    html += '<div class="mp-canvas-wrap"><canvas id="mockup-canvas" width="800" height="800"></canvas></div>';
    return html;
  }

  function init() {
    loadProductImages();

    var container = document.getElementById('mockup-preview');
    if (!container) {
      var uc = document.querySelector('.upload-choices');
      if (!uc) return;
      container = document.createElement('div');
      container.id = 'mockup-preview';
      container.innerHTML = buildPreviewHTML();
      uc.parentNode.insertBefore(container, uc.nextSibling);
    } else {
      var keys = Object.keys(PLACEMENTS);
      for (var i = 0; i < keys.length; i++) {
        if (document.getElementById('check_' + keys[i])) availablePlacements.push(keys[i]);
      }
    }
    if (availablePlacements.length === 0) return;
    canvas = container.querySelector('#mockup-canvas');
    if (!canvas) return;
    ctx = canvas.getContext('2d');

    container.querySelectorAll('.mp-tab').forEach(function (tab) {
      tab.addEventListener('click', function () { setActiveTab(tab.dataset.placement); });
    });
    Object.keys(PLACEMENTS).forEach(function (key) {
      var fileInput = document.getElementById('file_' + key);
      if (fileInput) {
        fileInput.addEventListener('change', function () { handleFileSelect(key, this); });
      }
    });
    setActiveTab(availablePlacements[0]);
  }

  function setActiveTab(placement) {
    activeTab = placement;
    var container = document.getElementById('mockup-preview');
    if (!container) return;
    container.querySelectorAll('.mp-tab').forEach(function (tab) {
      tab.classList.toggle('mp-tab--active', tab.dataset.placement === placement);
    });

    var view = PLACEMENTS[placement] ? PLACEMENTS[placement].view : 'front';
    currentMockup = viewImages[view] || viewImages.front || null;

    updateTabStates();
    draw();
  }

  function updateTabStates() {
    var container = document.getElementById('mockup-preview');
    if (!container) return;
    container.querySelectorAll('.mp-tab').forEach(function (tab) {
      var key = tab.dataset.placement;
      var cb = document.getElementById('check_' + key);
      var enabled = cb && cb.checked;
      tab.classList.toggle('mp-tab--enabled', enabled);
      tab.classList.toggle('mp-tab--has-file', !!uploadedImages[key]);
    });
  }

  function handleFileSelect(key, input) {
    if (input.files && input.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var img = new Image();
        img.onload = function () { uploadedImages[key] = img; updateTabStates(); setActiveTab(key); };
        img.src = e.target.result;
      };
      reader.readAsDataURL(input.files[0]);
    } else {
      delete uploadedImages[key];
      updateTabStates();
      draw();
    }
  }

  function draw() {
    if (!canvas || !ctx) return;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (currentMockup && currentMockup.complete && currentMockup.naturalWidth > 0) {
      var r = Math.min(canvas.width / currentMockup.width, canvas.height / currentMockup.height);
      var nw = currentMockup.width * r, nh = currentMockup.height * r;
      imgRect.x = (canvas.width - nw) / 2;
      imgRect.y = (canvas.height - nh) / 2;
      imgRect.w = nw;
      imgRect.h = nh;
      ctx.drawImage(currentMockup, imgRect.x, imgRect.y, nw, nh);
    }
    if (!activeTab) return;
    var placement = PLACEMENTS[activeTab];
    if (!placement) return;
    var zone = getZoneRect(placement);
    if (placement.view !== 'front') { drawViewLabel(placement); }
    ctx.save();
    ctx.strokeStyle = 'rgba(0, 200, 200, 0.7)';
    ctx.lineWidth = 2;
    ctx.setLineDash([8, 4]);
    ctx.strokeRect(zone.x, zone.y, zone.w, zone.h);
    ctx.restore();
    ctx.save();
    var labelText = placement.label + ' (' + placement.w + ' x ' + placement.h + ' in)';
    ctx.font = 'bold 14px sans-serif';
    var tw = ctx.measureText(labelText).width;
    var lx = zone.x + (zone.w - tw - 12) / 2;
    var ly = zone.y - 6;
    ctx.fillStyle = 'rgba(0, 150, 150, 0.85)';
    roundRect(ctx, lx, ly - 16, tw + 12, 22, 4);
    ctx.fill();
    ctx.fillStyle = '#fff';
    ctx.fillText(labelText, lx + 6, ly - 0);
    ctx.restore();
    if (uploadedImages[activeTab]) {
      ctx.save();
      ctx.globalAlpha = 0.88;
      drawImageContain(ctx, uploadedImages[activeTab], zone.x, zone.y, zone.w, zone.h);
      ctx.restore();
    }
  }

  function drawViewLabel(placement) {
    ctx.save();
    ctx.font = 'bold 18px sans-serif';
    var text = placement.view.charAt(0).toUpperCase() + placement.view.slice(1) + ' View';
    var tw = ctx.measureText(text).width;
    ctx.fillStyle = 'rgba(0,0,0,0.5)';
    roundRect(ctx, (canvas.width - tw - 20) / 2, 10, tw + 20, 30, 6);
    ctx.fill();
    ctx.fillStyle = '#fff';
    ctx.fillText(text, (canvas.width - tw) / 2, 31);
    ctx.restore();
  }

  function getZoneRect(placement) {
    var p = placement.pct;
    return {
      x: imgRect.x + p.x * imgRect.w,
      y: imgRect.y + p.y * imgRect.h,
      w: p.w * imgRect.w,
      h: p.h * imgRect.h
    };
  }

  function drawImageContain(ctx, img, x, y, w, h) {
    var r = Math.min(w / img.width, h / img.height);
    var nw = img.width * r, nh = img.height * r;
    ctx.drawImage(img, x + (w - nw) / 2, y + (h - nh) / 2, nw, nh);
  }

  function roundRect(ctx, x, y, w, h, r) {
    ctx.beginPath(); ctx.moveTo(x + r, y); ctx.lineTo(x + w - r, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + h - r);
    ctx.lineTo(x + w, y + h, x + w - r, y + h); ctx.lineTo(x + r, y + h);
    ctx.quadraticCurveTo(x, y + h, x, y + h - r); ctx.lineTo(x, y + r);
    ctx.quadraticCurveTo(x, y, x + r, y); ctx.closePath();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();